
export default class GradientOverlay {
  constructor(width= 1080, height=2340) {
    this.gradSprite = this.createGradientSprite();

    this.updateSize(width,height);
  }

  get gradientSprite (){
    return  this.gradSprite;
  }
  updateSize(width, height){
    this.gradSprite.width = height;
    this.gradSprite.height = width;

  }

  createGradientSprite(spriteWidth = 2340, spriteHeight = 2340) {
    const textureWidth = 500;
    const textureHeight = 500;
    // const gradTexture = createGradientTexture(textureWidth, textureHeight);
    const gradTexture = PIXI.utils.TextureCache['gradient'];;

    const sprite = new PIXI.Sprite(gradTexture);
    sprite.width = spriteWidth;
    sprite.height = spriteHeight;
    sprite.pivot.set(textureWidth/2, textureHeight/2);
    sprite.rotation = Math.PI / 2;
    return sprite;
  }

}
